import styled from "styled-components";
import palette from "../../lib/styles/palette";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const ProjectEditorBlock = styled.div`
    // 페이지 위아래 여백 지정
    width: 100%;
    margin: 0 auto;
    max-width: 1280px;
    margin-top: 5rem;
    padding: 2rem 1rem 0;
`;

const TitleInput = styled.input`
    display: block;
    font-size: 2rem;
    outline: none;
    padding-bottom: 0.5rem;
    border: none;
    border-bottom: 1px solid ${palette.gray[4]};
    margin-bottom: 2rem;
    width: 100%;
`;

const ContentInput = styled.input`
    display: block;
    font-size: 1rem;
    outline: none;
    padding-bottom: 0.5rem;
    border: none;
    border-bottom: 1px solid ${palette.gray[4]};
    margin-bottom: 2rem;
    width: 100%;
`;

const ProjectEditor = ({ onChangeField, title, body }) => {
    const language = useSelector(state => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    const onChangeTitle = (e) => {
        onChangeField({ key: 'title', value: e.target.value });
    }

    // const onChangeBody = (e) => {
    //     onChangeField({ key: 'body', value: e.target.value});
    // }

    const [comment, setComment] = useState(body.comment);
    const [contractDate, setContractDate] = useState(body.contractDate);
    const [contact, setContact] = useState(body.contact);

    const [localBody, setLocalBody] = useState({});

    useEffect(() => {
        setLocalBody({
            comment,
            contractDate,
            contact,
        })

        onChangeField({ key: 'body', value: localBody});
        
    }, [body, comment, contact, contractDate, localBody, onChangeField]);


    return (
        <ProjectEditorBlock>
            <TitleInput placeholder={isKR ? '프로젝트명을 입력하세요.' : isJP ? 'プロジェクト名を入力してください' : isEN ? 'Input the Project Title' : ''} onChange={onChangeTitle} value={title} />
            <ContentInput placeholder={isKR ? '프로젝트에 대해 자유롭게 써보세요' : isJP ? 'プロジェクトについて自由に書いてください' : isEN ? 'Describe the Project details' : ''} value={comment} onChange={ e => setComment(e.target.value) } />
            <ContentInput placeholder={isKR ? '계약 예정일 또는 현재상태' : isJP ? '契約予定日または現在の状態' : isEN ? 'Expected Contract Date or Current Status' : '' } value={contractDate} onChange={ e => setContractDate(e.target.value) } />
            <ContentInput placeholder={isKR ? '연락처(이메일)' : isJP ? '連絡先（メール）' : isEN ? 'Contact (E-mail)' : ''} value={contact} onChange={ e => setContact(e.target.value) } />
        </ProjectEditorBlock>
    );  
};

export default ProjectEditor;
